import React, { useContext } from 'react';
import assetAccountContext from '../../context/assetAccountContext';
import BalanceBar from './BalanceBar';
import AccountSummary from './AccountSummary';
import GainLossBar from './GainLossBar';
import AccountReportRoot from '../accountReport/AccountReportRoot';
import PortfolioReportroot from '../portfolioReport/PortfolioReportRoot';

type Props = {};

const AccountOverviewRoot: React.FC<Props> = () => {
  const { selectedAccount } = useContext(assetAccountContext);

  if (selectedAccount === undefined) {
    return null;
  }

  return (
    <>
      <BalanceBar />
      <AccountSummary />
      <GainLossBar />
      <AccountReportRoot />
      <PortfolioReportroot />
    </>
  );
};

export default AccountOverviewRoot;
